import { BIG_ZERO } from "../../util/bigNumber";
import BN from "bignumber.js";
import type { FarmAllocParams } from "./types";
import type { RequiredFarmChainType } from "@/constants/project-specific";
import type { ChainFarmData } from "@/constants/project-specific/farms/types";

export const getFarmAllocation = ({
  allocPoint,
  totalAllocPoint,
  totalSpecialAllocPoint,
  isRegular = true,
}: FarmAllocParams) => {
  const _allocPoint = allocPoint ? new BN(allocPoint.toString()) : BIG_ZERO;
  const totalAlloc = isRegular ? totalAllocPoint : totalSpecialAllocPoint;
  const poolWeight =
    !!totalAlloc && !!_allocPoint
      ? _allocPoint.div(totalAlloc.toString())
      : BIG_ZERO;

  return {
    poolWeight: poolWeight,
    multiplier: !_allocPoint.isZero()
      ? `${+_allocPoint.div(10).toString()}X`
      : `0X`,
  };
};

export function getTotalFarmTVLPerMasterchef(farms: ChainFarmData, farmChain: RequiredFarmChainType): number {
  const farmArray = farms[farmChain] || [];
  return farmArray.reduce((accum, farm) => {
    const totalValue = farm.totalValue ?? 0;
    return accum + (Number.isNaN(totalValue) ? 0 : totalValue);
  }, 0);
}

export function getTotalFarmsTVLPerChain(farms: ChainFarmData): Record<string, number> {
  const tvl: Record<string, number> = {};
  for (const chain in farms) {
    tvl[chain] = getTotalFarmTVLPerMasterchef(farms, Number(chain) as RequiredFarmChainType);
  }
  return tvl;
}

export function getTotalFarmTVLAllChains(farms: ChainFarmData): number {
  return Object.values(getTotalFarmsTVLPerChain(farms)).reduce((accum, tvl) => accum + tvl, 0);
}